<template>
  <div class="highlight-container row" v-if="hasProducts">
    <vue-element-loading :active="isLoadingAdd" is-full-screen></vue-element-loading>

    <div class="hightlight-container-title">
      <div class="highlight-title">
        <span>PRODUTOS EM<br /><b>DESTAQUES</b></span>
      </div>
    </div>
    <div class="highlight-slider-container">
      <div class="destaque">        
        <div class="slide-item" v-for="product in products" :key="product.id">
          <div class="highlight-product-container">
            <div class="highlight-img">              
              <div class="highlight-heart" v-on:click="handleFav">
                <!--
                <img
                  v-if="isFavorited == false"
                  class="heart-icon"
                  :src="app + '/public/images/site-representante/FAVNORMAL.png'"
                />
                <img
                  v-if="isFavorited == true"
                  class="heart-icon"
                  :src="
                    app + '/public/images/site-representante/FAVORITADO.png'
                  "
                />
                -->
              </div>              
              <img class="img-produto" :src="product.image" @error="imageNotFound" alt="" />
            </div>
            <div class="highlight-cart">
              <div class="car-container cart-highlight-content">
                <div class="product-fav-bar-dest mh-10px">
                  <span class="tag-promo" v-if="product.have_promotion">Promoção</span>
                </div>
                <div class="highlight-product-name">
                  <span class="desc_banner">{{ product.name }}</span
                  >
                  <small>Ref: {{ product.ref }}</small>
                </div>
                <div class="carrinho_prod">
                  <div class="price">
                    <template v-if="product.price">
                      <template v-if="product.have_promotion">
                        <span class="preco_orig"><s>{{ formatReal(product.price) }}</s></span>
                      </template>  
                    
                      <div class="preco_desc">
                        {{ price(product) }}
                        <span class="unit"> a unidade</span>
                      </div>                      
                    </template>
                  </div>

                  <small>Quantidade:</small>
                  <div class="input-number">
                    <button @click="decrement(product)">-</button>
                    <input type="text" name="number" min="0" max="1000" value="0" v-on:change="checkQuantity(product)" v-model="product.quantity" :readonly="alreadyAadded(product) != -1">                    
                    <button @click="increment(product)">+</button>
                  </div>
                  <small>Embalagem c/{{ parseInt(product.quantity_packaging) }} unidades cada</small>

                  <template v-if="isCustomerTypeSale && !product.price">
                    <span class="add-button btn-disabled" content="Produto não consta em sua lista de preço. Verifique o orçamento do produto com o seu representante." v-tippy='{ arrow : true }'>
                      CONSULTE SEU REPRESENTANTE    
                    </span>
                  </template>
                  <template v-else-if="product.blocked_status !== 'not-blocked'">
                    <button v-if="product.blocked_status === 'requested-notification'" class="notification-button notification-requested">
                      <img
                        :src="`${app}/public/images/site-representante/icon-clock.svg`"
                      />
                      AVISO PROGRAMADO
                    </button>
                    <button v-else class="notification-button notification-request" @click="requestNotification(product)">
                      <img
                        :src="`${app}/public/images/site-representante/icon-mail.svg`"
                      />
                      AVISE-ME QUANDO CHEGAR
                    </button>
                  </template>
                  <template v-else>
                    <button :class="[alreadyAadded(product) == -1 ? '' : 'btn-disabled', 'add-button']" @click="addProduct(product)">
                      <img
                        :src="app + '/public/images/site-representante/cart.png'"
                      />
                      {{ alreadyAadded(product) == -1 ? 'ADICIONAR' : 'ADICIONADO' }}
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="highlight-dots-container"></div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import formatMixin from '../../../../mixins/formatMixin';

export default {
  mixins: [formatMixin],
  props: [
    'isCustomerTypeSale',
  ],
  data() {
    return {
      app: ROOT_URL,
      isFavorited: false,
      products: [],
      isLoadingAdd: false,
    };
  },
  computed: {
    ...mapState({
      cartProducts: state => state.cart.products
    }),
    hasProducts: function() {
      return this.products.length > 0
    }
  },
  methods: {
    async fetchProducts() {
        let vm = this
        
        await this.axios.get(API_URL + '/home/featured-products').then(({ data }) => {
          vm.products = data.products.map(function(product) {
            product['quantity'] = parseInt(product.quantity_packaging);
            
            return product;
          })
				})

        $('.destaque').slick({
          dots: true,
          arrows: false,
          centerMode: false,
          infinite: false,
          speed: 600,
          slidesToShow: 1,
          slidesToScroll: 1,
          appendDots: '.highlight-dots-container',
        });
    },
    addProduct(product) {
      if (this.alreadyAadded(product) != -1) {
        return;
      } 

      const data = {
        produto_id: product.id,
        embalagem: product.quantity_packaging,
        quantidade: product.quantity
      };

      let vm = this;

      vm.isLoadingAdd = true;

      this.$store.dispatch('cart/addProduct', data).then(result => {
        vm.$toasted.success('Produto adicionado', {
          duration:3000, 
          keepOnHover: true
        });

        vm.isLoadingAdd = false;
      }).catch(error => {
        vm.$toasted.error(error, {
          duration:3000, 
          keepOnHover: true, 
          icon:'exclamation-circle'
        });      
        
        vm.isLoadingAdd = false;
      });
    },
    imageNotFound(event) {
      event.target.src = ROOT_URL + "/public/images/not-found/340-292/340-292.jpg";
    },
    handleFav: function (event) {
      event.preventDefault();
      this.isFavorited = !this.isFavorited;
    },
    increment(product) {
      if (this.alreadyAadded(product) == -1) {
        product.quantity += parseInt(product.quantity_packaging);
      }
    },
    decrement(product) {
      if (this.alreadyAadded(product) == -1) {
        product.quantity = Math.max(0, product.quantity - product.quantity_packaging);
      }
    },
    checkQuantity(product) {
      if (this.alreadyAadded(product) == -1) {
        product.quantity = parseInt(product.quantity_packaging ? Math.ceil(product.quantity / product.quantity_packaging) * product.quantity_packaging : product.quantity);
      }      
    },
    alreadyAadded(product) {
      let returnKey = -1;
      const search = product.id;

      $.each(this.cartProducts, function(key, info) {
        if (info.produto_id == search) {
          returnKey = key;
          
          return false; 
        };   
      });

      return returnKey; 
    },
    price(product) {
      return product.have_promotion ? this.formatReal(product.promotional_price) : this.formatReal(product.price);
    },
    requestNotification(product) {
      this.isLoadingAdd = true;

      const data = {
        product_id: product.id
      }

      this.axios.post(`${API_URL}/produtos-bloqueados/solicitar-notificacao`, data ).then(()=>{

        product.blocked_status = 'requested-notification';

        this.$fire({
          title: 'Aviso programado com sucesso!',
          text: 'Você receberá um e-mail quando este produto estiver disponível para compra.',
          type: 'success',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          customClass:   {
            title: 'notification-alert-title',
            confirmButton: 'notification-alert-confirm',
            content: 'notification-alert-text'
          }
        })
      }).catch(()=>{
        this.$toasted.error('Erro ao solicitar aviso de chegada', {
          duration:3000, 
          keepOnHover: true, 
          icon:'exclamation-circle'
        });      
      }).finally(()=>{
        this.isLoadingAdd = false;
      })
    },
  },
  mounted() {    
    this.fetchProducts();
  }
};
</script>

<style scoped>
.highlight-slider-container {
  width: 70%;
}
@media screen and (max-width:640px){
.highlight-slider-container {
  width: 100%;
}
}
.highlight-container {
  border: 1px solid #d7d7d7;
  background-color: white;
  padding: 10px;
  display: flex;
}
.highlight-cart {
  display: flex;
  padding: 20px;
}
.cart-highlight-content {
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  max-width: 250px;
}
.highlight-product-name {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.highlight-product-name span {
  text-align: center;
}
.highlight-product-name small {
  font-size: 12px;
  color: #999;
}
.highlight-product-container {
  display: flex;
}
.highlight-img {
  position: relative;
  padding: 20px;
}
.highlight-heart {
  position: absolute;
  right: 15px;
}
.hightlight-container-title {
  width: 30%;
  display: flex;
}
.highlight-title {
  background-color: #252642;
  padding-right: 15%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-clip-path: polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%);
  clip-path: polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%);
}
.highlight-title span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  color: white;
}
.highlight-title span b {
  font-size: 20px;
}

.highlight-dots-container {
  position: relative;
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 640px) {
  .highlight-container {
    flex-direction: column;
  }
  .hightlight-container-title {
    width: 100%;
  }
  .highlight-title {
    -webkit-clip-path: none;
    clip-path: none;
    padding: 10px 0;
  }
}
@media screen and (max-width: 545px) {
  .highlight-product-container {
    flex-direction: column;
  }
  .highlight-img {
    display: flex;
    justify-content: center;
  }
  .highlight-cart {
    justify-content: center;
  }
  .cart-highlight-content {
    max-width: none;
  }
}
</style>